// extracted by mini-css-extract-plugin
export default {"header":"styles__header___Q4Vdr"};